export function removeInvalidChars(str) {
  //this is also technically a diacritical, but I'd rather not mess with the previous routine.

  var knownChars = [];
  //var knownChars = [];

  //TODO: as we intercept bad characters, we update them here

  str = str.replaceAll("\u00B4", "'");
  str = str.replaceAll("\u2013", "-");
  str = str.replace(/[^\x00-\x7F]/g, "_");
  return str;
}
